export namespace SystemEventConstants {
  export const SYSTEM_MAINTENANCE: string = 'SystemEvent.SystemMaintenance';
  export const SYSTEM_MAINTENANCE_ENDED: string = 'SystemEvent.SystemMaintenanceEnded';
  export const VERSION_DEPRECATED: string = 'SystemEvent.VersionDeprecated';
}
